import { createSelector } from 'reselect'

import { getBreadcrumbsFromCategory } from '@/components/shared/breadcrumbs'
import type { Breadcrumb, CmsCustomPage } from '@/types/app-types'

import type { CustomPageState } from './types'

export const customPageSelector = createSelector(
    (state: CustomPageState) => state.data,
    (customPage: CmsCustomPage | undefined): CmsCustomPage | undefined => customPage,
)

export const breadcrumbSelector = createSelector(
    (state: CustomPageState) => state.data,
    (customPage: CmsCustomPage | undefined): Breadcrumb[] => {
        if (customPage?.category) {
            return getBreadcrumbsFromCategory(customPage.category, { isExternalLink: false })
        }
        return []
    },
)
